"use strict";

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App");

var $ = require("jquery");
var newsletterService = abp.services.api.newsletter;

module.exports = exports.default = function () {
    $("#add-newsletter-subscription").attr("tabindex", "");

    $("#btn-add-newsletter-subscription-submit").off("click").on("click", function () {
        var userId = $("#UserId").val();
        newsletterService.subscribe(userId).done(function (result) {
            $("#newslettersGrid").DataTable().ajax.reload(null, false);
            _notify2.default.success(resx.App.NewsletterSubscribed);
        }).fail(function (result) {
            _notify2.default.error(result.responseJSON.error.message);
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/newsletters.js
// module id = 444
// module chunks = 0